import { on } from '@ngrx/store';
import { ContentId } from '../../../types/content-block';
import { MaterialSerialNumber } from '../../../types/material-serial-number';
import { updateDescription, updateMaterialNumber, updateSerialNumber } from '../../actions/functional-elements.actions';
import { FormState } from '../../state/form.state';
import { updateStateAfterContentChanges } from './form-reducer.utilities';

export function updateMaterialSerialNumberReducer(
    state: Readonly<FormState>,
    props: { id: ContentId; xmlId: string; newValue: string },
    property: 'materialValue' | 'serialValue' | 'descriptionValue',
): Readonly<FormState> {
    const oldMaterialSerialNumber = state.participantCopies[state.selectedParticipantCopyId].functionalElements[
        props.id
    ] as MaterialSerialNumber;

    if (oldMaterialSerialNumber[property] === props.newValue) {
        return state;
    }

    // First: Create updated material-serial-number entry
    const newMaterialSerialNumber: { [key: string]: Readonly<MaterialSerialNumber> } = {};
    newMaterialSerialNumber[props.id] = {
        ...oldMaterialSerialNumber,
        [property]: props.newValue,
    };

    return updateStateAfterContentChanges(state, {
        ...state.participantCopies[state.selectedParticipantCopyId].functionalElements,
        ...newMaterialSerialNumber,
    });
}

export function updateMaterialNumberReducer(
    state: Readonly<FormState>,
    props: { id: ContentId; xmlId: string; newValue: string },
): Readonly<FormState> {
    return updateMaterialSerialNumberReducer(state, props, 'materialValue');
}

export function updateSerialNumberReducer(
    state: Readonly<FormState>,
    props: { id: ContentId; xmlId: string; newValue: string },
): Readonly<FormState> {
    return updateMaterialSerialNumberReducer(state, props, 'serialValue');
}

export function updateDescriptionReducer(
    state: Readonly<FormState>,
    props: { id: ContentId; xmlId: string; newValue: string },
): Readonly<FormState> {
    return updateMaterialSerialNumberReducer(state, props, 'descriptionValue');
}

export const materialSerialNumberReducer = [
    on<FormState, Array<typeof updateMaterialNumber>>(updateMaterialNumber, updateMaterialNumberReducer),
    on<FormState, Array<typeof updateSerialNumber>>(updateSerialNumber, updateSerialNumberReducer),
    on<FormState, Array<typeof updateDescription>>(updateDescription, updateDescriptionReducer),
];
